import React from 'react'
import './Footer.css'

export default function Footer() {
  return (
    <footer>© 2023 J-League Predicator</footer>
  );
}

